import type { CommonSVGProps } from './helpers';

export const DiscoverIconActive = (props: CommonSVGProps) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM11.0693 9.80371C10.7748 9.90189 10.5067 10.0675 10.2871 10.2871C10.0675 10.5067 9.90189 10.7748 9.80371 11.0693L8 16.4805L13.4111 14.6758C13.7056 14.5776 13.9729 14.4119 14.1924 14.1924C14.4119 13.9729 14.5776 13.7056 14.6758 13.4111L16.4805 8L11.0693 9.80371Z"
        fill="#292929"
        style={{
          fill: '#292929',
          fillOpacity: 1,
        }}
      />
    </svg>
  );
};
